module.exports = __webpack_public_path__ + "media/quanping.9ee442bd.mp4";